import { render, staticRenderFns } from "./SearchResultsTable.vue?vue&type=template&id=149499e7&"
import script from "./SearchResultsTable.vue?vue&type=script&lang=js&"
export * from "./SearchResultsTable.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports